export const BACKEND_UNAVAILABLE_ERROR = 'BackendUnavailable';
